import { render, staticRenderFns } from "./SelectOptionTable.vue?vue&type=template&id=50f06e4a&scoped=true&"
import script from "./SelectOptionTable.vue?vue&type=script&lang=js&"
export * from "./SelectOptionTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectOptionTable.vue?vue&type=style&index=0&id=50f06e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f06e4a",
  null
  
)

export default component.exports